module.exports = __webpack_public_path__ + "static/media/Nurse_using_the_Curoflow_telemedicine_software_at_primary_care_clinic.5dc7a72e.webp";